__turbopack_context__.v({
  "className": "inter_16bf1fe8-module__H5FXVa__className",
});
